export default __webpack_public_path__ + "static/media/agregarEspecialidad.1b00902e.svg";